import styled from "@emotion/styled";
import InputLabel from "@mui/material/InputLabel";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Layout from "components/structure/Layout";
import React, { useContext, useEffect, useState } from "react";
import { Button, Grid } from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { SnackbarContext } from "context/snackBarContext";
import { AuthData } from "auth/AuthWarpper";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import ImportHierarchyService from "services/ImportHierarchyService";

const ViewDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = AuthData();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const {
    // id,
    farmerLogId,
    farmerPropertyNumber,
    growerNumber,
    farmerName,
    state,
    farmerLta,
    operation,
    errorDescription,
    status
  } = location.state || {};

  const { setOpenAlert, setSeverity, setMessage } = useContext(SnackbarContext);
  const params = useParams();
  const { id } = params;

  useEffect(() => {
    callDetailsAPI();
  }, []);

  const callDetailsAPI = () => {
    setLoading(true);
    const query = {
      id: id
    };

    ImportHierarchyService.fetchFarmerDetail(query)
      .then((res) => {
        setData(res?.data?.response);
      })
      .catch((error) => {
        setData([]);
        setMessage(error?.response?.data?.message || error?.message)
        setOpenAlert(true)
        setSeverity("error")
        console.error("API call failed:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };


  return (
    <Layout title="Agri360 ESG Portal">
      <div style={{ paddingBottom: "4rem" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 2,
          }}
        >
          <Heading>Import Farmer</Heading>
          <Button
            sx={{
              borderRadius: 100,
              minWidth: 95,
              minHeight: 44,
              background: "#102A62",
            }}
            variant="contained"
            startIcon={<KeyboardBackspaceIcon />}
            onClick={() => navigate(-1)}
          >
            Back
          </Button>
        </Box>
        <PaperContainer>
          <form autoComplete="off">
            <Grid container spacing={2}>
              <Grid
                item
                md={6}
                xs={12}
                sx={{
                  display: { md: "flex", sx: "block" },
                  alignItems: "center",
                }}
              >
                <InputLabel sx={{ width: "10rem" }} htmlFor="my-input">
                  Operation
                </InputLabel>
                <Box>
                  <TextField
                    sx={{ width: { xs: "100%", md: "14rem" } }}
                    id="profileCode"
                    aria-describedby="my-helper-text"
                    label={""}
                    value={operation === null ? "" : operation}
                    name="profileCode"
                    disabled={true}
                  />
                </Box>
              </Grid>
              <Grid
                item
                md={6}
                xs={12}
                sx={{
                  display: { md: "flex", xs: "block" },
                  alignItems: "center",
                }}
              >
                <InputLabel sx={{ width: "10rem" }} htmlFor="my-input">
                  Status
                </InputLabel>
                <Box>
                  <TextField
                    sx={{ width: { xs: "100%", md: "14rem" } }}
                    id="profileCode"
                    aria-describedby="my-helper-text"
                    label={""}
                    value={status === null ? "null" : status}
                    name="profileCode"
                    disabled={true}
                  />
                </Box>
              </Grid>
              <Grid
                item
                md={12}
                xs={12}
                sx={{
                  display: { md: "flex" },
                  alignItems: "center",
                  flexDirection: "end",
                }}
              >
                <InputLabel sx={{ width: "10rem",alignSelf: "flex-start"  }} htmlFor="my-input">
                  Error Description
                </InputLabel>
                <Box>
                  <TextField
                    sx={{ width: { xs: "100%", md: "1000px !important" } }}
                    id="profileCode"
                    aria-describedby="my-helper-text"
                    label={""}
                    value={
                      errorDescription === null ? "null" : errorDescription
                    }
                    name="profileCode"
                    disabled={true}
                    multiline
                    rows={4}
                  />
                </Box>
              </Grid>
            </Grid>
          </form>
        </PaperContainer>
        <Box sx={{ mt: 1 }}>
          <PaperContainer>
            <form autoComplete="off">
              <Grid container spacing={2}>
                <Grid
                  item
                  md={4}
                  xs={12}
                  sx={{
                    display: { md: "flex", sx: "block" },
                    alignItems: "center",
                  }}
                >
                  <InputLabel sx={{ width: "10rem" }} htmlFor="my-input">
                    Property No
                  </InputLabel>
                  <Box>
                    <TextField
                      sx={{ width: { xs: "100%", md: "14rem" } }}
                      id="profileCode"
                      aria-describedby="my-helper-text"
                      label={""}
                      value={
                        farmerPropertyNumber === null ? "null" : farmerPropertyNumber
                      }
                      name="profileCode"
                      disabled={true}
                    />
                  </Box>
                </Grid>
                <Grid
                  item
                  md={4}
                  xs={12}
                  sx={{
                    display: { md: "flex", xs: "block" },
                    alignItems: "center",
                  }}
                >
                  <InputLabel sx={{ width: "10rem" }} htmlFor="my-input">
                    Grower No
                  </InputLabel>
                  <Box>
                    <TextField
                      sx={{ width: { xs: "100%", md: "14rem" } }}
                      id="profileCode"
                      aria-describedby="my-helper-text"
                      label={""}
                      value={data['grower-number']}
                      name="profileCode"
                      disabled={true}
                    />
                  </Box>
                </Grid>
                <Grid
                  item
                  md={4}
                  xs={12}
                  sx={{
                    display: { md: "flex", xs: "none" },
                    alignItems: "center",
                    flexDirection: "end",
                  }}
                >
                  <InputLabel sx={{ width: "10rem" }} htmlFor="my-input">
                    Farmer Name
                  </InputLabel>
                  <Box>
                    <TextField
                      sx={{ width: { xs: "100%", md: "14rem" } }}
                      id="profileCode"
                      aria-describedby="my-helper-text"
                      label={""}
                      value={
                        farmerName === null ? "null" : farmerName
                      }
                      name="profileCode"
                      disabled={true}
                    />
                  </Box>
                </Grid>
                <Grid
                  item
                  md={4}
                  xs={12}
                  sx={{
                    display: { md: "flex", sx: "block" },
                    alignItems: "center",
                  }}
                >
                  <InputLabel
                    sx={{ width: "10rem" }}
                    htmlFor="my-input"
                  >
                    State Province
                  </InputLabel>
                  <Box>
                    <TextField
                      sx={{ width: { xs: "100%", md: "14rem" } }}
                      id="my-input"
                      aria-describedby="my-helper-text"
                      label={""}
                      value={
                        state === null ? "null" : state
                      }
                      name="profileName"
                      disabled={true}
                    />
                  </Box>
                </Grid>
                <Grid
                  item
                  md={4}
                  xs={12}
                  sx={{
                    display: { md: "flex", sx: "block" },
                    alignItems: "center",
                  }}
                >
                  <InputLabel sx={{ width: "10rem" }} htmlFor="my-input">
                    Farmer LTA
                  </InputLabel>
                  <Box>
                    <TextField
                      sx={{ width: { xs: "100%", md: "14rem" } }}
                      id="my-input"
                      aria-describedby="my-helper-text"
                      label={""}
                      value={
                        farmerLta === null ? "null" : farmerLta
                      }
                      name="profileName"
                      disabled={true}
                    />
                  </Box>
                </Grid>
                <Grid
                  item
                  md={4}
                  xs={12}
                  sx={{
                    display: { md: "flex", xs: "flex" },
                    alignItems: "center",
                    flexDirection: "end",
                  }}
                >
                  <InputLabel sx={{ width: "10rem" }} htmlFor="my-input">
                    Gender
                  </InputLabel>
                  <Box>
                    <TextField
                      sx={{ width: { xs: "100%", md: "14rem" } }}
                      id="my-input"
                      aria-describedby="my-helper-text"
                      label={""}
                      value={data['gender']}
                      name="profileName"
                      disabled={true}
                    />
                  </Box>
                </Grid>
                <Grid
                  item
                  md={4}
                  xs={12}
                  sx={{
                    display: { md: "flex", xs: "flex" },
                    alignItems: "center",
                    flexDirection: "end",
                  }}
                >
                  <InputLabel sx={{ width: "10rem" }} htmlFor="my-input">
                    National ID
                  </InputLabel>
                  <Box>
                    <TextField
                      sx={{ width: { xs: "100%", md: "14rem" } }}
                      id="my-input"
                      aria-describedby="my-helper-text"
                      label={""}
                      value={data['national-id']}
                      name="profileName"
                      disabled={true}
                    />
                  </Box>
                </Grid>
                <Grid
                  item
                  md={4}
                  xs={12}
                  sx={{
                    display: { md: "flex", xs: "flex" },
                    alignItems: "center",
                    flexDirection: "end",
                  }}
                >
                  <InputLabel sx={{ width: "10rem" }} htmlFor="my-input">
                    City Town
                  </InputLabel>
                  <Box>
                    <TextField
                      sx={{ width: { xs: "100%", md: "14rem" } }}
                      id="my-input"
                      aria-describedby="my-helper-text"
                      label={""}
                      value={data['city']}
                      name="profileName"
                      disabled={true}
                    />
                  </Box>
                </Grid>
              </Grid>
            </form>
          </PaperContainer>
        </Box>
      </div>
    </Layout>
  );
};

const Heading = styled.div`
  color: rgba(115, 125, 134, 1);
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
`;

const PaperContainer = styled(Paper)`
  padding: 2rem 1rem;
`;

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin: 2rem 0;
`;

export default ViewDetails;
